module.exports = __webpack_public_path__ + "static/media/jiri-soul.a5a26bc3.png";